import { z } from "zod";

/**
 * The records a History panel can be opened on: the `root_table` values audit_log files each change
 * under. A bag, a bin or an address is filed under its document or vendor, so it is not listed here.
 */
export const AUDIT_ROOTS = [
  "documents",
  "lots",
  "gate_entries",
  "gate_passes_in",
  "gate_passes_out",
  "gate_parties",
  "qc_sample_requests",
  "qc_samples",
  "qc_srfs",
  "qc_density",
  "qc_density_reviews",
  "qa_staff",
  "qc_analysts",
  "locations",
  "facilities",
  "crop_categories",
  "crops",
  "classifications",
  "varieties",
  "sp_decode_map",
  "loss_types",
  "processing_resources",
  "operators",
  "pack_layouts",
  "mp_types",
  "production_personnel",
  "email_cc_recipients",
  "year_codes",
  "vendors",
  "users",
  "roles",
  "rbac_nodes",
  "stores_documents",
  "stores_items",
  "stores_classifications",
  "stores_uoms",
  "stores_parties",
  "stores_indents",
  "stores_reorder_orders",
  // Orders and Dispatch (0181).
  "customers",
  "orders",
] as const;
export type AuditRoot = (typeof AUDIT_ROOTS)[number];

/**
 * Who made a record and when, who last changed it and when — the "Created by / Updated by" every
 * form and list row shows. A null person with a time is a change nobody signed (a Core sync); both
 * null is a record older than the trail.
 */
export const recordStamps = z.object({
  createdBy: z.object({ id: z.number(), name: z.string() }).nullable(),
  createdAt: z.string().nullable(),
  updatedBy: z.object({ id: z.number(), name: z.string() }).nullable(),
  updatedAt: z.string().nullable(),
});
export type RecordStamps = z.infer<typeof recordStamps>;

/** The name a stamp shows. Unsigned changes (a Core sync) have a time and no person. */
export const stampWho = (p: RecordStamps["createdBy"], at: string | null) =>
  p ? p.name : at ? "System" : "—";
